"use strict";

import { RepeatFilmDialogModel } from "../models/repeatFilmDialogModel";

export class RepeatFilmService {
  static $inject = ["modalService", "Study"];

  constructor(modalService, Study) {
    this.modalService = modalService;
    this.study = Study;
  }

  async showRepeatFilmModal(ssn, sDate) {
    const [optionsResp, recordsResp] = await Promise.all([
      this.study.getRepeatFilmOptions(),
      this.study.loadRepeatFilms(ssn, sDate),
    ]);

    const model = new RepeatFilmDialogModel({
      ssn: ssn,
      sDate: sDate,
      projections: (optionsResp.data && optionsResp.data.Projections) || [],
      reasons: (optionsResp.data && optionsResp.data.Reasons) || [],
      records: recordsResp.data || [],
    });

    const result = await this.modalService.showDialogWindow(
      "views/templates/modals/repeat-film-modal.html",
      model,
      true
    );

    if (result && !result.cancelled && result.saved) {
      await this.study.saveRepeatFilms(ssn, sDate, result.records);
      return {
        saved: true,
        summary: result.getSummary(),
      };
    }

    return null;
  }

  async buildSummary(ssn, sDate) {
    const [optionsResp, recordsResp] = await Promise.all([
      this.study.getRepeatFilmOptions(),
      this.study.loadRepeatFilms(ssn, sDate),
    ]);

    const model = new RepeatFilmDialogModel({
      ssn: ssn,
      sDate: sDate,
      projections: (optionsResp.data && optionsResp.data.Projections) || [],
      reasons: (optionsResp.data && optionsResp.data.Reasons) || [],
      records: recordsResp.data || [],
    });

    return model.getSummary();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/repeatFilmService.js